/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { useProduct } from '@/data/Content/Product';
import { CatSEO } from '@/data/types/Category';
import { ProductDisplayPrice, ProductType, ResponseProductAttribute } from '@/data/types/Product';
import { getAttributeValueByIdentifier } from '@/utils/productAttributes';
import { get, partition } from 'lodash';

const EMPTY_SEO = {} as CatSEO;
const EMPTY_PRICE = {} as ProductDisplayPrice;
const EMPTY_PROD = {} as ProductType;
const EMPTY_ATTRS: ResponseProductAttribute[] = [];

export const useOrderItemTableRow = (
	partNumber: string,
	contractId?: string | string[],
	_orderItemId = ''
) => {
	const { product = EMPTY_PROD, loading } = useProduct({ id: partNumber, contractId });
	const {
		id,
		attributes = EMPTY_ATTRS,
		name = '',
		productPrice = EMPTY_PRICE,
		seo: { href = '' } = EMPTY_SEO,
		manufacturer = '',
		thumbnail:thumbnail1 = '',
		sellerId,
		seller,
	} = product;
	const thumbnail = thumbnail1?.replaceAll('hclstore','wcsstore').replace('wcsstore/wcsstore','wcsstore')
	const releaseDate:string = getAttributeValueByIdentifier(product?.attributes, "ITNL_ReleaseDate");
	const maxOrderLimit:string = getAttributeValueByIdentifier(product?.attributes,"ITNL_MaximumOrderLimit");
	const [colorAttributes, otherAttributes] = partition(
		attributes,
		({ identifier }) => identifier === 'Color'
	);
	const color = get(colorAttributes[0], 'values[0].value', '');

	return {
		details: {
			id,
			partNumber,
			name,
			color,
			thumbnail,
			href,
			prices: productPrice,
			attributes: otherAttributes,
			manufacturer,
			seller,
			sellerId,
			loading,
			releaseDate,
			maxOrderLimit
		},
	};
};
